import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from "app/hooks/useMediaQuery";
import './AppMenu.css';

SectionAppTitle.propTypes = {
    imgSrc:PropTypes.string,
    title:PropTypes.string,
};

function SectionAppTitle({
    imgSrc="http://placehold.jp/00bab4/ffffff/36.4x36.4.png",    
    title="", 
    ...props
}) {
    const isMobile = useMediaQuery('(max-width: 1279px)');
    return (
             
        <div className={`d-flex justify-content-start mb-4 ${isMobile && "w300"}`}>
            <div>
                <img className="sectionAppIcon" src={imgSrc} alt={title}/>                
            </div>                 
            <div className={`${isMobile ? "sectionAppTitleTextMobile pt-2": "sectionAppTitleText"}`}>{title}</div>
        </div>
    );
}

export default SectionAppTitle;